import React from "react";
import {
  withStyles,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";
import WithRowLabel from "./PickupComponents/WithRowLabel";

const styles = (theme) => ({
  radioGroupLabel: {
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    color: theme.popupLeftColColor,
  },
  radioLabelText: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    color: theme.radioLabelText,
  },
  checkboxLabel: {
    paddingRight: 32,
    marginBottom: 6,
    backgroundColor: theme.radioLabel,
    marginLeft: 0,
    marginRight: 8,
    borderRadius: 32,
  },
  activeRadio: {
    backgroundColor: theme.activeRadioBG,
  },
});

const CustomRadioGroup = ({
  classes,
  headerLabel,
  options,
  helperText,
  error,
  onChange,
  value,
}) => {
  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <FormControl component="fieldset" error={error}>
      <FormLabel
        component="legend"
        classes={{
          root: classes.radioGroupLabel,
        }}
        focused
      >
        {headerLabel}
      </FormLabel>
      <RadioGroup
        row
        aria-label="position"
        value={value}
        onChange={handleChange}
      >
        {options.map(option => (
          <FormControlLabel
            key={`dynamicRadioGrp_${option.value}`}
            classes={{
              root: `${classes.checkboxLabel} ${
                option.value === value ? classes.activeRadio : ""
              }`,
              label: classes.radioLabelText,
            }}
            value={option.value}
            control={<Radio color="primary" />}
            label={option.labelText}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

const StyledRadioGroup = withStyles(styles)(CustomRadioGroup);
const RadioGroupWithLabel = WithRowLabel(StyledRadioGroup);
export { StyledRadioGroup, RadioGroupWithLabel };
